import { createAction, props } from '@ngrx/store';
import { IContactSet } from '../interfaces/contact.interfaces';

export const setContacts = createAction(
	'[CONTACTS] Set Contacts',
	props<{ contacts: IContactSet[] }>()
);

export const addContact = createAction(
	'[CONTACTS] Add Contact',
	props<{ contact: IContactSet }>()
);

export const updateContact = createAction(
	'[CONTACTS] Update Contact',
	props<{ contact: IContactSet; pk: string }>()
);
export const removeContact = createAction(
	'[CONTACTS] Remove Contact',
	props<{ contactId: string }>()
);
